import styled from "styled-components";

export const Heading = styled.p`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const Subheading = styled.p`
  text-align: center;
  font-size: 1.2rem;
`;

export const Total = styled.p`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  margin: 1rem 0;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Error = styled.p`
  color: ${({ theme }) => theme.colors.error};
  text-align: center;
`;
